import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { ICardElementWithChildren } from "backend/model/model";
import ElementTreeViewItem from "./ElementTreeViewItem";
import flattenHierarchy from "backend/flattenHierarchy";

const useElementTreeViewStyles = makeThemedStyles(
  "ElementTreeView",
  (theme) => ({
    root: {
      margin: "0px",
      "& svg path": {
        fill: "#162870",
      },
    },
  })
);

const ElementTreeView = (
  props: React.PropsWithChildren<{
    selectedItem?: ICardElementWithChildren;
    items: ICardElementWithChildren[];
    onSelected?: (items: ICardElementWithChildren) => void;
  }>
) => {
  const { selectedItem } = props;
  const styles = useElementTreeViewStyles();
  const flatItems = React.useMemo(
    () => flattenHierarchy(props.items),
    [props.items]
  );
  const [expanded, setExpanded] = React.useState<string[]>([]);
  const [selected, setSelected] = React.useState<string[]>(
    selectedItem ? [selectedItem.id] : []
  );
  const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    console.log("toggle", event.target, nodeIds);
    /*
    if ((event.target as any).nodeName !== "svg") {
      return;
    }
    */
    setExpanded(nodeIds);
  };

  const handleSelect = (
    event: React.ChangeEvent<{}>,
    nodeIds: string | string[]
  ) => {
    console.log("toggle select", event.target, nodeIds);
    /*
    if ((event.target as any).nodeName === "svg") {
      return;
    }
    */
    if (typeof nodeIds === "string") {
      setSelected([nodeIds]);

      if (props.onSelected) {
        const [selectedItem] = flatItems.filter((item) => item.id === nodeIds);
        if (selectedItem) {
          props.onSelected(selectedItem);
        }
      }
    }
  };

  return (
    <TreeView
      className={styles.root}
      classes={styles}
      defaultCollapseIcon={null}
      defaultExpandIcon={null}
      expanded={flattenHierarchy(props.items).map((item) => item.id)}
      selected={selected}
      onNodeToggle={handleToggle}
      onNodeSelect={handleSelect}
    >
      {props.items.map((item) => (
        <ElementTreeViewItem key={item.id} item={item} />
      ))}
    </TreeView>
  );
};

export default ElementTreeView;
